import httpClient from '../httpClient';

const info = async (id) => {
  return await httpClient.get(`/mass_modification_payments/${id}/info/`);
};

const post = async (data) => {
  return await httpClient.post('/mass_modification_payments/', data);
};

const put = async (id, data) => {
  return await httpClient.put(`/mass_modification_payments/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/mass_modification_payments/${id}/`);
};

const view_home = async (query, page = 1, pageSize = 10, search = false) => {
  return await httpClient.get(
    `/mass_modification_payments/view_home/?page[number]=${page}&page[size]=${pageSize}&filter[modificacion]=${query}${
      search ? `&filter[search]=${search}` : ''
    }`,
  );
};

const filter = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_modification_payments/export/?filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_modification_payments/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const patchModule = async (id, data) => {
  return await httpClient.patch(
    `/mass_modification_payments/${id}/update_module/`,
    data,
  );
};

const productsTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'codigo',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';
  if (search) searchBy = '&filter[search]=' + search;

  const url = `/mass_modification_payment_products/?filter[modulo_modificacion]=${query}&page[number]=${page}&page[size]=${pageSize}&sort=${sortBy}${searchBy}`;

  if (exportCSV)
    return await httpClient.get(
      `/mass_modification_payment_products/export/?filter[modulo_modificacion]=${query}&sort=${sortBy}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else return await httpClient.get(url);
};

const productsAssignTable = async (query = '', data) => {
  return await httpClient.post(
    `mass_modification_payment_products/?filter[modulo_modificacion]=${query}`,
    data,
  );
};

const productInfo = async (id, params) =>
  await httpClient.get(`mass_modification_payment_products/${id}/info/`, {
    params: params,
  });

export {
  info,
  post,
  put,
  remove,
  filter,
  patchModule,
  view_home,
  productsTable,
  productsAssignTable,
  productInfo,
};
